<template>
  <b-container fluid>
    <page-title icon="fas fa-tachometer-alt" :countdown="countdown" :countdown-max="60">
      <translate>Summary</translate>
    </page-title>
    <b-card class="list-filters">
      <b-row>
        <b-col>
          <b-row>
            <b-col md="3">
              <p>
                <b-form-checkbox
                  id="all-statuses"
                  v-model="allStatuses"
                  :value="true"
                  :unchecked-value="false"
                >
                  <translate>Show all statuses</translate>
                </b-form-checkbox>
              </p>
            </b-col>
            <b-col>
              <label for="inline-form-input-name">
                <translate>Date Range (120 days max.)</translate>
              </label>
              <label for="inline-form-input-name" v-show="updatedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetupdatedDateRange"><translate>reset range</translate></a>]</label>
              <date-range-picker
                id="inline-form-input-name"
                v-if="this.locale.daysOfWeek"
                v-model="updatedDateRange"
                :locale-data="locale"
                :opens="opens"
                class="mb-2 w-100"
                :ranges="ranges"
                :min-date="minDate"
                @update="updateValues"
              >
                <template #input="picker">
                  <div style="top: 3px;position:relative">
                    <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                    <span v-if="updatedDateRangeActive === 0" style="vertical-align: middle"><translate>Last 7 days</translate></span>
                    <span v-else style="vertical-align: middle">{{moment(updatedDateRange.startDate).format('L')}} - {{moment(updatedDateRange.endDate).format('L')}}</span>
                  </div>
                </template>
              </date-range-picker>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="p-0">
      <b-row>
        <b-col v-for="(total, i) in totals" :key="i" sm="6" md="3">
          <h6><b-badge :variant="total > 0 ? 'secondary' : 'dark'"><big>{{total}}</big></b-badge> <b-link target="_blank" :href="'/shippings/list?qf=' + makeLink([i])">{{ i }}</b-link></h6>
        </b-col>
        <b-col sm="6" md="3">
          <h6><b-badge :variant="workedCouriers > 0 ? 'secondary' : 'dark'"><big>{{workedCouriers}}</big></b-badge> <translate>Couriers</translate></h6>
        </b-col>
        <b-col sm="6" md="3">
          <h6><b-badge :variant="generalStalled > 0 ? 'danger' : 'dark'"><big>{{generalStalled}}</big></b-badge> <b-link v-if="utcGeneralStalledDateTo" target="_blank" :href="'/shippings/list?qf=%7B%22status%22%3A%5B%22CONFIRMED%22%2C%22ATPICKUPPOINT%22%2C%22ATDELIVERYPOINT%22%2C%22INTRANSIT%22%2C%22TOBERETURNED%22%2C%22INCIDENCE%22%5D%2C%22shipping-updated-at%22%3A%7B%22startDate%22%3A%22' + utcGeneralStalledDateFrom.utc().toDate() + '%22%2C%22endDate%22%3A%22' + utcGeneralStalledDateTo.utc().toDate() + '%22%2C%22dateRangeActive%22%3Atrue%7D%7D'" v-translate>General Stalled</b-link></h6>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col sm="6" lg="3" v-for="(company, index) in summary" :key="index" v-if="((!allStatuses && (company.statuses.READY || company.statuses.DRAFT)) || allStatuses)">
        <b-card>
          <b-card-title class="mb-1">
            <input type="checkbox"
              class="mr-2"
              v-model="companiesCollection"
              :value="{company_id: company.company_id, name: company.name}"
              :aria-label="company.name"
              v-if="company.company_id && !allStatuses"
              />
            <b-link :to="{name: 'CompaniesEdit', params: {id: company.company_id}}" target="_blank" v-if="company.company_id">
              {{company.name}}
            </b-link>
            <span v-else>{{company.name}}</span>
          </b-card-title>
          <b-card-text>
            <div class="mb-2" v-if="company.operators || company.cut_time">
              <b-badge pill variant="info">Cut time {{ moment(company.cut_time).format('L LT') }} hs</b-badge>
              <b-badge pill v-for="(operator, index) in company.operators" :key="index" v-if="company.operators">
                {{ operator.name }}
              </b-badge>
            </div>
            <b-row v-if="company.schedule_for && company.schedule">
              <b-col>
                <hr class="mt-0 mb-1">
                <dl class="mb-0">
                  <dt>Schedule for {{company.schedule_for}}</dt>
                  <dd class="mb-0" v-if="company.schedule">
                    {{ company.schedule[0].from }} to {{ company.schedule[0].to}}
                    <span v-if="company.schedule[1]"> and {{ company.schedule[1].from }} to {{ company.schedule[1].to}}</span>
                  </dd>
                </dl>
                <hr class="my-1">
              </b-col>
            </b-row>
            <div v-for="(status, i) in company.statuses" :key="i" v-if="(!allStatuses && (i === 'READY' || i === 'DRAFT')) || allStatuses">
              <b-badge>{{status}}</b-badge>
              <b-link target="_blank" :href="'/shippings/list?qf=' + makeLink([i], [company.company_id], [company.name])" v-if="company.company_id">{{ i }}</b-link>
              <span v-else>{{ i }}</span>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="companiesCollection.length">
      <b-col class="text-center">
        <b-button target="_blank" :href="'/shippings/list?qf=' + collectionQs" v-translate>Open Listing with selected</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import clone from 'lodash/clone'
import DateRangePicker from 'vue2-daterange-picker'

export default {
  name: 'SummaryPage',
  title() {
    return this.$gettext('Summary')
  },
  components: {
    DateRangePicker
  },
  data() {
    return {
      summary: [],
      totals: {},
      companiesCollection: [],
      collectionQs: '',
      utcDateFrom: null,
      utcDateTo: null,
      date_from: this.moment().subtract(6, 'day').startOf('day'),
      date_to: this.moment().subtract(0, 'day').endOf('day'),
      updatedDateRange: { // used for v-model prop
        startDate: this.moment().subtract(6, 'day').toDate(),
        endDate: this.moment().toDate()
      },
      opens: 'right',
      locale: {
        direction: 'ltr',
        format: this.$gettext('mm/dd/yyyy'),
        separator: ' - ',
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(),
        monthNames: this.moment.monthsShort(),
        firstDay: 1,
        showWeekNumbers: false
      },
      ranges: {
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').toDate(), this.moment().toDate()],
        [this.$gettext('Last 120 days')]: [this.moment().subtract(119, 'day').toDate(), this.moment().toDate()]
      },
      updatedDateRangeActive: 0,
      minDate: '',
      maxDate: this.moment().toDate(),
      allStatuses: false,
      filterByCutTime: false,
      intervalSummary: null,
      intervalCountdown: null,
      countdown: 60,
      workedCouriers: 0,
      checkCount: 0,
      checkFixed: 0,
      generalStalled: null,
      utcGeneralStalledDateFrom: null,
      utcGeneralStalledDateTo: null
    }
  },
  watch: {
    updatedDateRangeActive: {
      handler (val) {
        if (val !== 0) {
          this.date_from = this.moment(this.updatedDateRange.startDate)
          this.date_to = this.moment(this.updatedDateRange.endDate)
        } else {
          this.date_from = this.moment().subtract(6, 'day')
          this.date_to = this.moment().subtract(0, 'day')
        }
        this.setTimeout()
      },
      deep: true
    },
    companiesCollection(val) {
      if (val.length) {
        this.makeCollectionLink()
      }
    },
    allStatuses(val) {
      if (val) {
        this.companiesCollection = []
      }
    },
    pendingOnly: 'setTimeout',
    filterByCutTime: 'setTimeout',
    workingOnSat: 'setTimeout',
    workingOnSun: 'setTimeout'
  },
  mounted() {
    this.setTimeout()
  },
  beforeDestroy() {
    clearTimeout(this.intervalSummary)
    clearInterval(this.intervalCountdown)
  },
  methods: {
    setTimeout() {
      clearTimeout(this.intervalSummary)
      this.intervalSummary = setTimeout(function () {
        this.setTimeout()
      }.bind(this), 60000)
      this.getSummary()
      this.getGeneralStalled()
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    filterPreferences(summary) {
      let response = []
      if (this.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.profile.meta)
        } catch (e) {
          meta = this.profile.meta
        }
        if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length === 0 && meta.backofficePreferences.companies.exclude.ids.length > 0) {
          response = summary.filter(x => !meta.backofficePreferences.companies.exclude.ids.includes(x.company_id))
        } else if (meta.backofficePreferences && meta.backofficePreferences.companies.include.ids.length > 0) {
          response = summary.filter(x => meta.backofficePreferences.companies.include.ids.includes(x.company_id))
        } else {
          response = summary
        }
      } else {
        response = summary
      }
      return response
    },
    getGeneralStalled() {
      this.utcGeneralStalledDateFrom = this.moment().tz(this.$tz).clone().subtract(15, 'day').startOf('day')
      this.utcGeneralStalledDateTo = this.moment().tz(this.$tz).clone().subtract(1, 'day').endOf('day')

      const params = {
        limit: 1,
        filter_groups: [
          {
            filters: [
              ['updated_at', 'bt', [this.utcGeneralStalledDateFrom.utc().format('YYYY-MM-DD HH:mm:ss'), this.utcGeneralStalledDateTo.utc().format('YYYY-MM-DD HH:mm:ss')]],
              ['status', 'in', ['CONFIRMED', 'ATPICKUPPOINT', 'INTRANSIT', 'ATDELIVERYPOINT', 'INCIDENCE', 'TOBERETURNED']],
              ['shipping_type_id', 'eq', this.flexesTypeId, 'true']
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', { params })
        .then(response => {
          this.generalStalled = response.body.pagination.total
        })
    },
    fetchWorkingCouriers() {
      const params = {
        limit: 1,
        filter_groups: [
          {
            filters: [
              ['created_at', 'bt', [this.utcDateFrom.utc().format('YYYY-MM-DD HH:mm:ss'), this.utcDateTo.utc().format('YYYY-MM-DD HH:mm:ss')]]
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['user.country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'couriers/worked', { params })
        .then(response => {
          this.workedCouriers = response.body.pagination.total
        })
    },
    getSummary() {
      this.countdown = 60
      this.setIntervalCountdown()
      this.utcDateFrom = this.date_from.tz(this.$tz).startOf('day').clone()
      this.utcDateTo = this.date_to.tz(this.$tz).endOf('day').clone()

      const params = {
        date_to: this.utcDateTo.utc().format('YYYY-MM-DD'),
        time_to: this.utcDateTo.utc().format('HH:mm:ss'),
        date_from: this.utcDateFrom.utc().format('YYYY-MM-DD'),
        time_from: this.utcDateFrom.utc().format('HH:mm:ss'),
        filter_by: 'updated_at',
        filter_by_cut_time: this.filterByCutTime,
        working_on_sat: this.workingOnSat,
        working_on_sun: this.workingOnSun
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.from_country_iso_code = window.country
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/summarize', { params })
        .then(response => {
          const summary = response.body
          new Promise(function (resolve, reject) {
            resolve(this.filterPreferences(summary))
          }.bind(this))
            .then(response => {
              this.summary = response

              const statuses = [
                'DRAFT',
                'READY',
                'CONFIRMED',
                'ATPICKUPPOINT',
                'INTRANSIT',
                'ATDELIVERYPOINT',
                'DELIVERED',
                'INCIDENCE',
                'TOBERETURNED',
                'RETURNED',
                'CANCELED'
              ]

              for (const status of statuses) {
                this.totals[status] = this.summary.reduce((total, obj) => (obj.statuses[status] || 0) + total, 0)
              }
            })
        })
      this.fetchWorkingCouriers()
      this.minDate = this.moment(clone(this.date_from)).subtract(120, 'days').toDate()
    },
    makeLink(status, companyIds, names) {
      //   warehouse: this.filterWarehouse ? ['from_place_id', 'eq', this.filterWarehouse] : []
      const qf = {
        status,
        'shipping-updated-at': {
          startDate: this.date_from.clone().startOf('day').format('YYYY-MM-DD'),
          endDate: this.date_to.clone().endOf('day').format('YYYY-MM-DD'),
          dateRangeActive: true
        }
      }
      if (companyIds) {
        qf['shipping-company'] = companyIds.map((id, i) => {
          return {
            id,
            name: names[i]
          }
        })
      }

      return encodeURIComponent(JSON.stringify(qf))
    },
    makeCollectionLink() {
      this.collectionQs = this.makeLink(
        ['DRAFT', 'READY'],
        this.companiesCollection.map(company => {
          return company.company_id
        }),
        this.companiesCollection.map(company => {
          return company.name
        })
      )
    },
    resetupdatedDateRange() {
      this.updatedDateRange = {
        startDate: this.moment().subtract(6, 'day').toDate(),
        endDate: this.moment().toDate()
      }
      this.updatedDateRangeActive = 0
    },
    updateValues(obj) {
      this.updatedDateRangeActive++
    }
  }
}
</script>
